
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#A2B8C6","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#F4F6F9","x":".5","y":".5","width":"58","height":"16","rx":"3"}}),_c('path',{attrs:{"fill":"#A2B8C6","d":"M43.5 16.5h1v-15h-1z"}}),_c('rect',{attrs:{"fill":"#F4F6F9","x":".5","y":"21.5","width":"58","height":"16","rx":"3"}}),_c('path',{attrs:{"fill":"#F4F6F9","d":"M43.5 36.5h1v-15h-1z"}}),_c('rect',{attrs:{"fill":"#F4F6F9","x":".5","y":"42.5","width":"58","height":"16","rx":"3"}}),_c('path',{attrs:{"fill":"#F4F6F9","d":"M43.5 57.5h1v-15h-1z"}})])])
          )
        }
      }
    